import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";

import crewModal from "./crewModal";
import deleteModal from "./deleteModal";
import deliveryModal from "./deliveryModal";
import editModal, {
  confirmEditModalEpic,
  toggleEditModalEpic,
} from "./editModal";
import loadReportModal, {
  epic as loadReportModalEpic,
} from "./loadReportModal";
import printWorkOrderModal, {
  epic as printWorkOrderModalEpic,
} from "./printWorkOrderModal";
import settingsModal from "./settingsModal";

import appintmentCalendarModal, {
  confirmAppointmentModalEpic,
  confirmEditApptModalEpic,
  toggleAppointmentModalEpic,
  toggleEditAppoinmentModalEpic,
  confirmIndividualAppointmentModalEpic,
  confirmSplitAppointmentModalEpic,
} from "./appintmentCalendarModal";

import { confirmSplitEditModalEpic } from "./editModal";

export * from "./crewModal";
export * from "./deleteModal";
export * from "./deliveryModal";
export * from "./editModal";
export * from "./loadReportModal";
export * from "./printWorkOrderModal";
export * from "./appintmentCalendarModal";

export default combineReducers({
  crewModal,
  deleteModal,
  deliveryModal,
  editModal,
  loadReportModal,
  printWorkOrderModal,
  settingsModal,
  appintmentCalendarModal,
});

export const epics = combineEpics(
  confirmEditModalEpic,
  toggleEditModalEpic,
  printWorkOrderModalEpic,
  loadReportModalEpic,
  confirmAppointmentModalEpic,
  toggleAppointmentModalEpic,
  toggleEditAppoinmentModalEpic,
  confirmEditApptModalEpic,
  confirmIndividualAppointmentModalEpic,
  confirmSplitAppointmentModalEpic,
  confirmSplitEditModalEpic
);
